import PropTypes from 'prop-types';

import { CheckedSVG } from '../assets/svgs';

const StepsProgressBar = ({
  activeStep,
  steps,
  linesWidth,
  onClick,
}) => (
  <div className="steps-progress-bar">
    {steps.map((step, index) => (
      <button
        key={step.id}
        type="button"
        className="progress-point"
        onClick={() => onClick && onClick(index)}
        style={{ pointerEvents: onClick ? 'all' : 'none' }}
      >
        <div className="flex-center-row">
          <div
            className={`line ${index <= activeStep ? 'active' : ''} width-for-step-line`}
            style={{ width: linesWidth }}
          />
          <div className={`circle ${index <= activeStep ? 'active' : ''}`}>
            {index < activeStep ? <img src={CheckedSVG} alt="checked-img" /> : <span />}
          </div>
          <div
            className={`line ${index < activeStep ? 'active' : ''} width-for-step-line`}
            style={{ width: linesWidth }}
          />
        </div>
        <p
          className="mb-0 bold-text"
          style={{ fontWeight: index !== activeStep ? 400 : 700 }}
        >
          {step.tabTitle}
        </p>
      </button>
    ))}
  </div>
);

StepsProgressBar.defaultProps = {
  linesWidth: 50,
  onClick: null,
};

StepsProgressBar.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      tabTitle: PropTypes.string,
    })).isRequired,
  linesWidth: PropTypes.number,
  onClick: PropTypes.func,
};

export default StepsProgressBar;
